import styled from 'styled-components';
import { DOWN_ARROW, IC_SEARCH } from '../../../Assets/images/index';

const SearchDropDownStyled = styled.div`
  .customSearchDropdown {
    position: relative;

    .dropdownInput {
      .inputField {
        background: url(${DOWN_ARROW.src}) no-repeat;
        background-size: 12px 6px;
        background-position: calc(100% - 16px) 70%;
        font-weight: 600;
        font-size: 16px;
        color: ${(props) => props.theme.text.dark};
      }
    }
    .inputField {
      caret-color: transparent;
    }
    
    .select-search-demo-container {
      position: absolute;
      top: 60px;
      width: 100%;
      background: ${(props) => props.theme.color.white};
      border: 1px solid ${(props) => props.theme.color.border};
      border-radius: 8px;
      overflow: hidden;
      display: block !important;
      z-index: 3;
      .select-search-demo-value {
        position: relative;

        .select-search-input {
          background: ${(props) => props.theme.blue.extraLight} url(${IC_SEARCH.src}) no-repeat 17px 50% / 18px;
          padding: 16px 44px;
          border: 0;
          height: 52px;
          border-radius: 8px;
          border-bottom-right-radius: 0;
          border-bottom-left-radius: 0;
          font-weight: 600;
          font-size: 16px;
          line-height: 20px;
          color: ${(props) => props.theme.text.dark};
          width: 100%;
        }
        .closeButton {
          position: absolute;
          right: 16px;
          top: 16px;
          padding: 0;
          z-index: 1;
          cursor: pointer;
        }
      }

      .select-search-demo-select {
        border-top: 1px solid ${(props) => props.theme.color.border};
        border-radius: 8px;
        border-top-right-radius: 0;
        border-top-left-radius: 0;
        left: -1px;
        right: -1px;
        overflow: auto;
        max-height: 248px;
        .select-search-demo-options {
          list-style: none;
          padding: 0 15px;
          margin: 0;
          .select-search-demo-option {
            display: block;

            width: 100%;
            padding: 16px 0;
            background: transparent;
            border: none;
            border-bottom: 1px solid ${(props) => props.theme.color.lightGray};
            outline: none;
            text-align: left;
            font-style: normal;
            font-weight: 600;
            font-size: 15px;
            line-height: 18px;
            color: ${(props) => props.theme.text.dark};
          }
          .select-search-demo-row:last-child {
            .select-search-demo-option {
              border-bottom: 0;
            }
          }
          .select-search-demo-not-found {
            padding: 90px 0px;
            font-weight: 600;
            font-size: 15px;
            line-height: 19px;
            text-align: center;
            color: ${(props) => props.theme.text.medium};
          }
        }
      }
    }
  }
`;

export default SearchDropDownStyled;